import React, { useState,useEffect } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { AiOutlineArrowsAlt } from "react-icons/ai";
import { BsSuitHeart,BsSuitHeartFill } from "react-icons/bs";
import { BsThreeDots } from "react-icons/bs";
import { AiTwotoneTag } from "react-icons/ai";
import { GiStarShuriken } from "react-icons/gi";
import { useParams } from "react-router-dom";
import ProductTab from "./ProductTab";
import useAuth from "../../Hooks/useAuth";

Modal.setAppElement("#root");
const ProductDetails = () => {
  const [details,setDetails] = useState({})
  const {id} = useParams()
  const {detailsInfo,showDummyImage} = useAuth()
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [popupImg, setPopupImg] = useState(false);
  const [showOption,setShowOption] = useState(false);
  const [love,setLove] = useState(false);
  const [count,setCount] = useState(5)

   const openModal = () => {
    setModalIsOpen(true);
  }
  const closeModal = () => {
    setModalIsOpen(false);
  }
  const PopupImg = () => {
    setPopupImg(true);
  }
  const ClosePopupImg = () => {
    setPopupImg(false);
  }
  useEffect(()=>{
    const newData = detailsInfo?.find(item => parseInt(item?.id) === parseInt(id))
    setDetails(newData)
  },[detailsInfo,id])
  const handleCounter =()=>{
    if(!love){
      setCount(count+1)
    }else{
      setCount(count-1)
    }
  }
  return (
    <section className="product-details">
      <div className="container">
        <div className="pd-wrapper">
          <div className="pd-top">
            <div className="pd-top-left">
              <div className="pd-top-left-img">
                {
                  details?.image && <img src={require(`${process.env.REACT_APP_DISCOVER_IMAGE}${details?.image}`)} alt="" onError={({currentTarget},imageSize='570X465')=>showDummyImage({currentTarget},imageSize)}/>
                }
              </div>
              <div className="pd-zoomer">
                <button className="pd-zoomer-btn" onClick={PopupImg}>
                  <AiOutlineArrowsAlt />
                </button>
                <Modal
                  className="product-modal"
                  isOpen={popupImg}
                  onRequestClose={ClosePopupImg}
                  overlayClassName="Overlay"
                >
                  <div className="popup-img">
                    {
                      details?.image && <img src={require(`${process.env.REACT_APP_DISCOVER_IMAGE}${details?.image}`)} alt={'productOne'} onError={({currentTarget},imageSize='570X465')=>showDummyImage({currentTarget},imageSize)}/>
                    }
                  </div>
                </Modal>
              </div>
            </div>
            <div className="pd-top-right">
              <div className="pd-title">
                <h3>{details?.title}</h3>
                <div className="pd-title-action">
                  <button className="pd-title-action-btn" onClick={()=>
                   {   
                    setLove(!love) 
                    handleCounter()
                  }
                    }>
                    {
                      love ? <BsSuitHeartFill/>:<BsSuitHeart />
                    } 
                    <span>{count}</span>
                  </button>
                  <button className="pd-title-action-btn" onClick={()=>setShowOption(!showOption)}>
                    <BsThreeDots />
                  </button>
                  <div className={`product-option ${showOption ?"show-option":" "}`} onMouseLeave={()=>setShowOption(false)}>
                    <ul>
                      {Array.from({length:3}).map((_,i)=>
                          <li key={i} onClick={()=>setShowOption(false)}>Option-1</li>
                      )}
                    </ul>
                </div>
                </div>
              </div>
              <div className="on-sale">
                <div className="on-sale-icon">
                  <AiTwotoneTag />
                </div>
                <small>On sale for </small>
                <span>0.45 Flow</span>
              </div>
              <p className="pd-pera">
               {details?.details}
              </p>
                <button className="pd-pera-readmore-btn">
                  Read more....
                </button>
              <div className="owners">
                {
                  Array.from({length:parseInt(details?.owners)}).map((_,i)=><div key={i} className="owner">
                  <h6>Creator 0% royalties</h6>
                  <div className="owner-meta">
                    <div className="owner-profile">
                      <img src={require("../../assets/images/product/owner.png")} alt={'owner'} onError={({currentTarget},imageSize='50X50')=>showDummyImage({currentTarget},imageSize)}/>
                    </div>
                    <span>0x5573b...f98e</span>
                  </div>
                </div>)
                }
              </div>
              <div className="pd-top-btns">
                <button className="pd-top-btn active" onClick={openModal}>
                  Buy for {details?.price} Flow
                </button>
                <button className="pd-top-btn">Place a Bid</button>
                <Modal
                  className="modal"
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  overlayClassName="Overlay"
                >
                  <div className="modal-wallet">
                    <GiStarShuriken className="modal-wallet-icon" />
                    <p>
                      Get started with your Ethereum wallet to sign messages and
                      send transactions to Ethereum blockchain
                    </p>
                    <Link to={"/connectwallet"} className="modal-wallet-btn">
                      Connet wallet
                    </Link>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
          <div className="pd-bottom">
            <ProductTab />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetails;
